import { idbGet, idbPut, STORES } from './database';

export interface GitHubSource {
  owner: string;
  repo: string;
  branch: string;
}

const KEY_TOKEN = 'githubToken';
const KEY_SOURCE = 'githubSource';

export async function getGitHubToken(): Promise<string> {
  return (await idbGet<string>(STORES.settings, KEY_TOKEN)) ?? '';
}

export async function saveGitHubToken(token: string): Promise<void> {
  await idbPut(STORES.settings, token, KEY_TOKEN);
}

/** The repo/branch the currently-loaded project came from, or null if it's a local folder. */
export async function getGitHubSource(): Promise<GitHubSource | null> {
  return (await idbGet<GitHubSource>(STORES.settings, KEY_SOURCE)) ?? null;
}

export async function saveGitHubSource(source: GitHubSource | null): Promise<void> {
  await idbPut(STORES.settings, source, KEY_SOURCE);
}
